<script setup lang="ts">
import { useLivekit } from '@/composables/livekit'

const { t } = useI18n()
const { endCall, endCallLoading } = useLivekit()

const open = defineModel<boolean>('open', { default: false })

const emit = defineEmits<(e: 'end-success') => void>()

const openModal = () => {
  open.value = true
}

const closeModal = () => {
  open.value = false
  return true
}
</script>

<template>
  <OModal
    v-model:open="open"
    :primary-action-title="t('disconnect')"
    :secondary-action-title="t('cancel')"
    :primary-action-loading="endCallLoading"
    :primary-action-enabled="!endCallLoading"
    :secondary-action-enabled="!endCallLoading"
    :secondary-action-promise="closeModal"
    :primary-action-promise="
      async () => {
        const ok = await endCall()
        if (ok) emit('end-success')
        return true
      }
    "
    danger
    :title="t('confirm_disconnection?')"
  >
    <template #content>
      <div>{{ t('Are you sure you want to disconnect immediately?') }}</div>
    </template>
  </OModal>

  <slot :handle-click="openModal" />
</template>
